import React from 'react';
import { components } from 'react-select';

class WhiteLabelPluginOption extends React.Component {
  render() {
    const { data } = this.props;
    return <components.Option {...this.props}>{data.label}</components.Option>;
  }
}

class WhiteLabelPluginValue extends React.Component {
  render() {
    const { data } = this.props;

    return <div className="Select-value">{data.label}</div>;
  }
}

const whiteLabelPluginOptionFormatter = options => {
  return options.list.map(option => {
    return whiteLabelPluginSingleOptionFormatter(option);
  });
};

const whiteLabelPluginSingleOptionFormatter = option => {
  return {
    ...option,
    value: option.id,
    label: option.name,
  };
};

const whiteLabelPluginOptionFromEntity = whiteLabelPlugin => {
  return !whiteLabelPlugin
    ? null
    : whiteLabelPluginSingleOptionFormatter({
        id: whiteLabelPlugin.getId(),
        name: whiteLabelPlugin.getName(),
      });
};

export {
  WhiteLabelPluginOption,
  WhiteLabelPluginValue,
  whiteLabelPluginOptionFormatter,
  whiteLabelPluginSingleOptionFormatter,
  whiteLabelPluginOptionFromEntity,
};
